import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';

import { Keyword } from 'ish-core/models/keyword/keyword.model';
import { PipesModule } from 'ish-core/pipes.module';

@Component({
  selector: 'ish-suggest-keywords',
  templateUrl: './suggest-keywords.component.html',
  imports: [CommonModule, PipesModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestKeywordsComponent {
  readonly keywords = input<Keyword[]>(undefined);
  readonly maxAutoSuggests = input<number>(undefined);
  readonly inputTerms$ = input(new ReplaySubject<string>(1));
  readonly submitSearch = output<string>();

  submit(term: string) {
    this.submitSearch.emit(term);
  }
}
